export default __webpack_public_path__ + "static/media/ipet02.dbe06fd4.png";